import { Box } from "@mui/material"
import { CountryCode } from "@secureo/common/typings/CountryCode"
import { makeStyles } from "makeStyles"
import Link from "../../components/i18n/Link"

import { Category } from "../../typings/Category"
import getValueFromLocalizedStringWithFallback from "../../utils/i18n/getValueFromLocalizedStringWithFallback"

const useStyles = makeStyles()({
	fakeTabs: {
		display: "flex",
		justifyContent: "flex-start",
		flexFlow: "wrap",
	},
	listItem: {
		position: "relative",
		padding: "6px 13px 6px 13px",
		boxSizing: "border-box",
		marginBottom: "2px",
		border: "1px solid lightgrey",
		borderRadius: 5,
		background: "white",
		transition: "0.3s",
		boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1)",
		"&:hover": {
			background: "rgba(122, 191, 172, 0.2)",
			border: "1px solid #7abfac",
		},
	},
})

const SubCategoryList = ({ category, locale, countryCode }: Props) => {
	const { classes } = useStyles()
	const { children = [] } = category

	return (
		<div className={classes.fakeTabs}>
			{children
				.filter(
					(category) =>
						category.showInNavbar &&
						!category.excludedCountryCodes?.includes(countryCode),
				)
				.map((category) => {
					const { id, slug } = category
					const name = getValueFromLocalizedStringWithFallback(
						category.nameAllLocales,
						locale,
					)
					const href = `/c/${slug}`
					return (
						<Link href={href} key={id}>
							<Box px={2} m={1} ml={0} className={classes.listItem}>
								{name}
							</Box>
						</Link>
					)
				})}
		</div>
	)
}

export interface Props {
	category: Category
	locale: string
	countryCode: CountryCode
}

export default SubCategoryList
